import { CheckCircle2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { VALUES, IMAGES } from "@/data/site";

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Left: copy */}
          <div>
            <Reveal>
              <span className="eb-overline text-brand-blue">About Echo Bravo</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-[2.7rem] leading-[1.08] tracking-tight font-black text-navy-900">
                A maritime consultancy built on operational depth and international perspective.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-navy-700/80 font-medium">
                Echo Bravo is an independent advisory firm serving Shipowners,
                Operators, Charterers and Investors. We combine sea-going command
                experience with shore-side commercial and technical leadership to
                turn complex maritime challenges into measurable advantage.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-8 border-l-2 border-brand-blue pl-6">
                <span className="eb-overline text-silver-400">Our Mission</span>
                <p className="mt-3 text-lg leading-relaxed text-navy-900 font-semibold">
                  To safeguard and elevate the performance of every fleet we advise,
                  protecting assets, people and the marine environment while creating
                  durable commercial value.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <div className="mt-9 grid sm:grid-cols-2 gap-x-8 gap-y-5">
                {VALUES.map((v) => (
                  <div key={v.title} className="flex gap-3" data-testid={`value-${v.title.toLowerCase()}`}>
                    <CheckCircle2 size={20} className="mt-0.5 shrink-0 text-brand-blue" />
                    <div>
                      <div className="font-bold text-navy-900">{v.title}</div>
                      <div className="text-sm leading-relaxed text-navy-700/70">{v.text}</div>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          {/* Right: floating image over silver block */}
          <Reveal delay={0.1} className="relative">
            <div className="absolute -bottom-6 -right-4 h-[88%] w-[78%] bg-silver-200 hidden sm:block" aria-hidden />
            <div className="absolute -top-5 -left-4 hidden sm:flex flex-col bg-navy-900 text-white px-7 py-6 z-20 shadow-xl">
              <span className="text-4xl font-black tracking-tight">25+</span>
              <span className="text-xs uppercase tracking-[0.15em] text-silver-400 font-semibold mt-1">
                Years combined<br />maritime leadership
              </span>
            </div>
            <img
              src={IMAGES.about}
              alt="Echo Bravo maritime advisory team in strategy session"
              className="relative z-10 w-full h-[420px] sm:h-[520px] object-cover"
              loading="lazy"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
